import { Component, OnInit, OnDestroy } from '@angular/core'
import { ViewService,  HttpService } from '../shared/'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Subscription } from 'rxjs'
import { HttpResponse } from '@angular/common/http'

declare var jQuery: any;

@Component({
	selector: 'html-container',
	template: require('./html-container.component.html'),
	styles: [require('./html-container.component.scss')]
})

export class HtmlContainerComponent implements OnInit, OnDestroy {

	private SelectorGadget: any;
	private insertScript2Content = false;
	private busy: Subscription;
	private srcdoc: SafeHtml = '';

	constructor(private _service: HttpService, private sanitizer: DomSanitizer,
		private _viewService: ViewService) {
	}

	onNavigate(nav) {
		window.history.pushState({key: 'link', value: this._service.current_url}, document.title, '');
		this.busy = this._service.load(nav.url, nav.post_params, nav.action).subscribe(response =>
										this.setIFrameContent(response),
										error => this._viewService.errorAlert(error),
										() => console.log('Finished'));
	}

	getFrameWindowRef()	{
		return (<HTMLFrameElement>document.getElementById('frame_container')).contentWindow;
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}

	setIFrameContent(resp: HttpResponse<string>) {
//////////////
/////////////////////////////////////
///////////////////////////////////////////////////////
///////////////////////////////////////////
//////////////////////////////////////////////////
/////////////////////////////////
///

////////////////////////////////////////////
/////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////
////////////

		this.srcdoc = this.sanitizer.bypassSecurityTrustHtml(resp.body);
		this._service.current_url = resp.headers.get('Url');
	}

	onLoad() {
//////////////
//////////////////////////////////////
//////////
//////
///////////////////////////////////////////////////
//////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////
////////////
	}

	enableSelector() {
		this.SelectorGadget.enableSelector();
	}

	disableSelector() {
		this.SelectorGadget.disableSelector();
	}

	addScript(doc: HTMLDocument, script_str: string, inline: boolean) {
		let script: HTMLScriptElement = doc.createElement('script');
		script.type = 'text/javascript';
		if (!inline) {
			script.src   = script_str;
		} else {
			script.text  = script_str;
		}

		let head = doc.getElementsByTagName('head')[0];
		if (head) {
			head.appendChild(script);
		} else {
			doc.body.appendChild(script);
		}
	}

	addCSS(doc: HTMLDocument, css_link: string) {
		let css = doc.createElement('link');
		css.rel = 'stylesheet';
		css.href = css_link;
		let head = doc.getElementsByTagName('head')[0];
		if (head) {
			head.appendChild(css);
		} else {
			doc.body.appendChild(css);
		}
	}

	addBase(url: string) {
		let _url = new URL(url);
		let baseUrl = _url.protocol + '//' + _url.host + '/';
		let pathArray = _url.pathname.split('/');
		for (let i = 1; i < pathArray.length - 1; i++) {
			baseUrl += pathArray[i] + '/';
		}
		let doc = this.getFrameWindowRef().document;
		let base = doc.createElement('base');
		base.href = baseUrl;
		let head = doc.getElementsByTagName('head')[0];
		if (head) {
			head.appendChild(base);
		} else {
			doc.body.appendChild(base);
		}
	}
}

let xhrReplacement = `<script type="text/javascript">
function getBaseUrl(current_url) {
	var url = new URL(current_url);
	var baseUrl = url.protocol + "//" + url.host + "/";
	var pathArray = current_url.split('/');
	/* for (var i = 1; i <pathArray.length - 1; i++) {
		baseUrl += pathArray[i] + '/';
	} */
	return baseUrl;
}
var open = window.XMLHttpRequest.prototype.open,
send = window.XMLHttpRequest.prototype.send;

function openReplacement(method, url, async, user, password) {
this._url = url;
/* console.log(getBaseUrl(current_url));
url = 'http://localhost:8000/proxy?url=' + encodeURIComponent(getBaseUrl(current_url) + url);
console.log(url); */
return open.apply(this, arguments);
}

function sendReplacement(data) {
if(this.onreadystatechange) {
  this._onreadystatechange = this.onreadystatechange;
}
this.onreadystatechange = onReadyStateChangeReplacement;
return send.apply(this, arguments);
}

function onReadyStateChangeReplacement() {

//YOUR CODE FOR READYSTATECHANGE
parent.postMessage({
	msg: 'xhrQuery'
}, '*');

if(this._onreadystatechange) {
  return this._onreadystatechange.apply(this, arguments);
}
}

window.XMLHttpRequest.prototype.open = openReplacement;
window.XMLHttpRequest.prototype.send = sendReplacement; </script>`;
